import { Select, SelectProps } from '@fox/atoms/src/select';
import { tryParseJSONObject } from '@fox/atoms/utils';
import { FormRenderMode, QuestionStyleTypes } from '../../../../../form-runtime-context/contracts';
import { useFormRuntimeContext, useQuestionStyle } from '../../../../../form-runtime-context/form-runtime-context';
import { DataTableCustomFieldComponentArgs, Option, RenderSelectEditProps } from '../helpers';

export const SelectCustomField = ({ questionId, field, row, handleChange }: DataTableCustomFieldComponentArgs) => {
	const { formRenderMode } = useFormRuntimeContext();

	const val = tryParseJSONObject<string[]>(row?.[field.fieldId]);

	const { fontSize, fontFamily, color, fontStyle, textDecoration, fontWeight } = useQuestionStyle(QuestionStyleTypes.answer, {}, questionId);

	const { allowMulti, options } = tryParseJSONObject<RenderSelectEditProps>(field.meta) ?? {};

	if (!options) return;

	const selectedOptions = options.filter(o => val?.includes(o.id));

	const commonProps: Pick<SelectProps<Option, boolean, false, false>, 'sx' | 'options' | 'getOptionLabel' | 'size'> = {
		sx: {
			'.MuiInputBase-root': {
				color,
				fontSize,
				fontStyle,
				fontFamily,
				textDecoration,
				fontWeight
			},
			'input:focus, textarea': {
				border: '0',
				boxShadow: 'none'
			}
		},
		options: options,
		getOptionLabel: o => o.label,
		size: 'small'
	};

	if (allowMulti) {
		return (
			<Select<Option, true, false, false>
				multiple
				{...commonProps}
				value={selectedOptions}
				onChange={(e, v) => {
					if (formRenderMode === FormRenderMode.design) return;
					handleChange(v.length > 0 ? JSON.stringify(v.map(o => o.id)) : '', row.rowId, field.fieldId);
				}}
				getChipLabel={o => o.label}
			/>
		);
	} else {
		return (
			<Select<Option, false, false, false>
				{...commonProps}
				value={selectedOptions[0]}
				onChange={(e, v) => {
					if (formRenderMode === FormRenderMode.design) return;
					handleChange(v ? JSON.stringify([v.id]) : '', row.rowId, field.fieldId);
				}}
			/>
		);
	}
};
